import { renderSanitizedMarkdown } from "@/lib/markdown";
import { cn } from "@/lib/utils";

/**
 * A markdown body rendered in its surroundings' own colour.
 *
 * Headings, bold text and list markers inherit, so the same block reads inside
 * a notice, a chat bubble or a card without anything re-colouring it. The
 * markup comes from `renderSanitizedMarkdown`, which drops raw HTML and unsafe
 * URLs — the only renderer safe to point at user-submitted text.
 *
 * Callers add what is theirs: link colour, heading size, the surrounding text
 * colour. `openLinksInNewTab` sends outside links to a new tab and leaves
 * in-page `#` links in place.
 */
export default function MarkdownProse({ content = "", className, openLinksInNewTab = false }) {
  return (
    <div
      className={cn(
        "prose prose-sm max-w-none break-words text-inherit",
        "prose-headings:mb-2 prose-headings:mt-3 prose-headings:text-inherit",
        "prose-p:my-1 prose-p:leading-relaxed prose-strong:text-inherit",
        "prose-ol:my-2 prose-ul:my-2 prose-li:my-0.5",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: renderSanitizedMarkdown(content, { openLinksInNewTab }) }}
    />
  );
}
